import { render, staticRenderFns } from "./gptEqu.vue?vue&type=template&id=4ab35706&scoped=true"
import script from "./gptEqu.vue?vue&type=script&lang=js"
export * from "./gptEqu.vue?vue&type=script&lang=js"
import style0 from "./gptEqu.vue?vue&type=style&index=0&id=4ab35706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab35706",
  null
  
)

export default component.exports